<template>
  <div class="misc-wrapper">
    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          You are not authorized! 🔐
        </h2>
        <vs-button
          size="large"
          class="my-2 btn-sm-block"
          @click="loginRoute()"
        >Back to Login</vs-button>
        <b-img
          fluid
          :src="imgUrl"
          alt="Not authorized page"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      downImg: require('@/assets/images/pages/not-authorized.svg'),
    }
  },
  computed: {
    imgUrl() {
      // if (store.state.appConfig.layout.skin === 'dark') {
      //   // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      //   this.downImg = require('@/assets/images/pages/not-authorized-dark.svg')
      //   return this.downImg
      // }
      return this.downImg
    },
  },
  methods: {
    loginRoute() {
      let routeData = this.$router.resolve({ name: 'DigiLogin' });
      window.open(routeData.href, '_self');
    },
  },
}
</script>

<style lang="scss">
.brand-logo {
  svg {
    height: 28px;
    width: 40.95px;
  }
}

.misc-wrapper {
  display: flex;
  flex-basis: 100%;
  min-height: 100vh;
  width: 100%;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;

  .brand-logo {
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    position: absolute;
    top: 2rem;
  }

  .misc-inner {
    position: relative;
    max-width: 750px;
  }
}
</style>
